// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VModal from 'vue-js-modal'
import GlobalFilters from './plugins/GlobalFilters'
import Notifications from 'vue-notification'

require('./libs/notifications.css')
Vue.config.productionTip = false

Vue.use(VModal, { dialog: true })
Vue.use(GlobalFilters)
Vue.use(Notifications)

// Apply persisted theme to <body data-bs-theme> before mount
store.commit('setTheme', store.getters.theme)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js